import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FleetService {

  constructor(private readonly httpClient: HttpClient) { }

  // 200: configured, 401: tech user missing, 403: group unassigned (error codes are surfaced to the caller).
  isDatabaseConfigured(): Observable<any> {
    return this.httpClient.get(environment.apiEndpoint + 'fleets/configured');
  }

}
